import { JobBean }  from './job.bean';

export class SelectItemJobBean extends JobBean{
    constructor (){
        super()
        this.param={itens:[]}
    }
    public associateJob(writData){       

    }
    public testJob(writTest,job,wrt){
      if (writTest.triggerKind=='onClick'){
        wrt.jobs[writTest.id].completed=true;
                  wrt.jobs[writTest.id].completed=true;
                  let date=new Date();
                  wrt.jobs[writTest.id].dateEnd=date.getTime();   
                  this._companyService.getUserWrit(this._appData.instagramUser,writTest.group.toString()).set(wrt).then(val=>{              
                  })
        return true;
      }
      else{
        return false;
      }

    }
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/quests/SelectItemJob.ts